export default "images/车灯开启情况-前雾灯指示灯.png";